export default __webpack_public_path__ + "static/media/Carrusel_04.935b4d3d.png";